<div class="item item--missing-feature" margin-bottom-small>
  <rt-icon
    name="close"
    [hasAutoHeight]="true"
    [colorToken]="trial ? 'colorIconDefault' : 'colorIconCriticalDefault'"
    margin-right-small-x
  />

  @if (!missingFeature.link) {
    <span>{{ missingFeature.title }}</span>
  }
  @if (missingFeature.link && !missingFeature.items) {
    <a [href]="missingFeature.link | translate" target="_blank">{{
      missingFeature.title | translate
    }}</a>
  }

  <div class="multipart-label">
    @if (missingFeature.items) {
      @for (item of missingFeature.items; track trackByValue(i, item); let i = $index) {
        @if (item.link) {
          <a [href]="item.link | translate" target="_blank">{{ item.title | translate }}</a>
        }
        @if (!item.link) {
          <span margin-right-small-xx margin-left-small-xx>
            {{ item.title | translate }}
          </span>
        }
      }
    }
  </div>

  @if (trial && missingFeature.description) {
    <rt-icon
      name="help-outline"
      [hasAutoHeight]="true"
      margin-left-small-x
      [rtTooltip]="missingFeature.description | translate"
    />
  }
</div>
